/* Enhance native Shopify contact forms. No payment, reservations or Ajax sends. */
(() => {
  const format = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
  const pending = new WeakMap();
  function updateDate(form) {
    // LA calendar date, refreshed at interaction as well as load (midnight-safe).
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const date = Object.fromEntries(parts.map(p=>[p.type,p.value]));
    form.querySelectorAll('[data-order-date]').forEach(input=>{input.min=`${date.year}-${date.month}-${date.day}`;});
  }
  function validate(input) {
    if (!input.matches('input, textarea') || input.type === 'radio') return;
    input.setCustomValidity(input.required && !input.disabled && input.value && !input.value.trim() ? 'Please enter a value, not only spaces.' : '');
  }
  function resetSubmission(form) {
    pending.delete(form);
    form.removeAttribute('aria-busy');
    const button = form.querySelector('button[type="submit"]');
    if (button && form.dataset.reviewBlocked !== 'true') button.disabled = false;
    const status = form.querySelector('[data-submit-status]');
    if (status) status.textContent = '';
  }
  function refresh(form) {
    form.setAttribute('data-order-ready','');
    const selected = form.querySelector('[data-order-price]:checked');
    const total = form.querySelector('[data-order-total]');
    const amount = Number(selected?.dataset.orderPrice);
    if (total) total.textContent = selected && Number.isFinite(amount) ? format.format(amount / 100) : 'Choose a size';
    const delivery = form.querySelector('[data-order-fulfillment]')?.value === 'Local delivery (fee to be confirmed)';
    const field = form.querySelector('[data-delivery-field]');
    const postcode = form.querySelector('[data-order-postcode]');
    if (field) field.hidden = !delivery;
    if (postcode) { postcode.required = !!delivery; postcode.disabled = !delivery; }
    const custom = form.querySelector('[data-order-flavor]:checked')?.value === 'Custom flavor';
    const customField = form.querySelector('[data-custom-flavor-field]');
    const customInput = form.querySelector('[data-custom-flavor]');
    if (customField) customField.hidden = !custom;
    if (customInput) { customInput.required = custom; customInput.disabled = !custom; }
    form.querySelectorAll('input, textarea').forEach(validate);
  }
  function init(root) {
    root.querySelectorAll('[data-order-request]').forEach(form => {
      updateDate(form);
      refresh(form);
    });
  }
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-order-request]');
    if (form) refresh(form);
  });
  document.addEventListener('input', event => {
    if (event.target.closest('[data-order-request]')) {
      validate(event.target);
      event.target.removeAttribute('aria-invalid');
    }
  });
  document.addEventListener('focusin', event => {
    const form = event.target.closest('[data-order-request]');
    if (form) updateDate(form);
  });
  document.addEventListener('psb:form-restored', event => {
    if (event.target.matches('[data-order-request]')) refresh(event.target);
  });
  // Capture first so an offline or repeated attempt never starts native navigation.
  // Keep native POST + Shopify spam protection; never retry or claim success here.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-order-request]') || event.defaultPrevented || form.dataset.reviewBlocked === 'true') return;
    const previous = pending.get(form);
    if (previous && !previous.defaultPrevented) { event.preventDefault(); return; }
    updateDate(form);
    refresh(form);
    if (!form.reportValidity()) { event.preventDefault(); return; }
    const error = form.querySelector('[data-submit-error]');
    if (!navigator.onLine) {
      event.preventDefault();
      if (error) { error.textContent='You are offline. Reconnect, then send your request. Your details are still here.'; error.hidden=false; error.focus(); }
      return;
    }
    if (error) error.hidden = true;
    pending.set(form, event);
    // Shopify may cancel this event to show its challenge. Do not lock that path.
    setTimeout(() => {
      // A cancelled challenge may be retried before this task runs. An older
      // event must never unlock or alter the newer submission.
      if (pending.get(form) !== event) return;
      if (event.defaultPrevented) { resetSubmission(form); return; }
      form.setAttribute('aria-busy','true');
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      const status = form.querySelector('[data-submit-status]');
      if (status) status.textContent='Sending your request…';
    }, 0);
  }, true);
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-order-request]').forEach(resetSubmission);
    init(document);
  });
  init(document);
})();
